import { Component } from 'react';

import {
  SCREEN_ID_APPLICATION_STARTER,
} from 'client/constants/screenIds';

import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import HouseholdActions from 'client/actions/Household';

@withTransitionHook
@withScreenId(SCREEN_ID_APPLICATION_STARTER)
@branch()
class ApplicationStarterPage extends Component {
  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(HouseholdActions.roommateApplicationStep, {
      listingId: parseInt(match.params.listingId, 10),
    });
  }

  render() {
    return null;
  }
}

ApplicationStarterPage.displayName = 'ApplicationStarterPage';

export default ApplicationStarterPage;
